export type CreditStyle = "full-name" | "initials" | "anonymous";

export interface TestimonialSubmission {
  quote: string;
  creditStyle: CreditStyle;
  name?: string;
  city?: string;
  consentGiven: boolean;
}

/**
 * Captures a customer-submitted testimonial for moderation. Currently
 * simulates the request locally (like leadCapture.ts's submitLead); swap
 * the body for a real call to a Cloud Function once one exists (it would
 * write to a Firestore moderation queue — see ZP-41). Every submission goes
 * through this one function so that swap is one file, not a site-wide
 * search-and-replace.
 */
export async function submitTestimonial(submission: TestimonialSubmission): Promise<{ ok: true }> {
  if (import.meta.env.DEV) {
    console.info("[testimonialSubmission] would POST to moderation-queue Cloud Function:", submission);
  }
  // TODO(backend): POST to a real endpoint, e.g.
  // await fetch("/api/testimonials", { method: "POST", body: JSON.stringify(submission) });
  await new Promise((resolve) => setTimeout(resolve, 500));
  return { ok: true };
}
